import { render, staticRenderFns } from "./SubforumThumbnail.vue?vue&type=template&id=87f5cc18&"
import script from "./SubforumThumbnail.vue?vue&type=script&lang=js&"
export * from "./SubforumThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./SubforumThumbnail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports